import { MenuStructure } from "./types";

export const MENU_STRUCTURE_NEW: MenuStructure = {
  sampleReports: {
    checkIns: {
      items: {
        "Check-Ins": {
          title: "Check-Ins",
          description:
            "See how AI-powered check-in conversations give managers actionable insights and early warnings about their team's wellbeing and performance.",
          isNew: true,
        },
      },
    },
    teamScan: {
      items: {
        "TEAMscan Survey": {
          title: "TEAMscan Survey",
          description:
            "Preview one question from each of the four teamwork areas in this survey.",
        },
        "Team-level Report": {
          title: "Team-level Report",
          description:
            "This is a sample report any team leader or member gets after their team has completed the TEAMscan.",
        },
        "Department-level Report": {
          title: "Department-level Report",
          description:
            "This is a sample report any department leader gets after teams in their department have completed the TEAMscan.",
        },
        "Organization Report": {
          title: "Organization Report",
          description:
            "This is a sample report any admin gets after teams in the organization have completed the TEAMscan.",
        },
      },
    },
    personalityInsights: {
      items: {
        "Individual Personality Report": {
          title: "Individual Personality Report",
          description:
            "This is where you will find sample Workplace Insights Reports (for self-awareness) as well as sample Collaboration Guides and Manager Guides.",
        },
        "Team Personality Report": {
          title: "Team Personality Report",
          description:
            "This is a sample team-level personality report. This report is generated for any team whose members take or connect the Employee Personality Profile. Visibility can be set in settings.",
        },
      },
    },
    profiles: {
      items: {
        "User Profile": {
          title: "User Profile",
          description:
            "This is a sample user profile where you can share more about yourself and your role with your teammates.",
        },
        "Team Profile": {
          title: "Team Profile",
          description:
            "This is a sample team profile where your team can share what the team does, your core values, and key resources with other teams.",
        },
      },
    },
  },
  quickActions: {
    setupOrganization: {
      items: {
        "Add People to Organization": {
          title: "Add People to Organization",
          description:
            "This enables you to add them to teams or make them team leaders.",
        },
        "Create a new team": {
          title: "Create a new team",
          description:
            "Create a team of your direct reports and assign yourself or another teammate as team leader. Suggestion: Only create teams you directly manage.",
        },
        "Set Up Departments": {
          title: "Set Up Departments",
          description:
            "Set up your departments structure to enable easier onboarding and analytics.",
        },
      },
    },
    checkIns: {
      items: {
        "Launch Check-Ins": {
          title: "Launch Check-Ins",
          description:
            "Launch check-ins for your organization or a subset in order to receive full organizational transparency.",
        },
      },
    },
    launchTEAMscan: {
      items: {
        "Launch TEAMscan": {
          title: "Launch TEAMscan",
          description:
            "Launch the survey for a single team, one or more departments, or your entire organization.",
        },
      },
    },
  },
};
